export const manageSubscriptionsIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Student Subscriptions page is where you can assign subscriptions to students.'
  },
  {
    element: '#customizeDiagnosticSchedule',
    intro: 'Contact your WordFlight Implementation Lead to learn more about changing the schedule of a Diagnostic.'
  },
];
